import { PAYMENTS_EXPORT_URL, PAYMENTS_FILTER_URL, PAYMENTS_REDUCE_URL } from 'constants/ApiConstants';
import { PaymentStatus, PAYMENT_TYPE } from 'constants/PaymentConstants';

import * as types from './actionTypes';

/**
 * @param {Object} params
 * @param {object} [meta={}]
 * @returns {FetchPaymentsRequestAction}
 */
export const fetchPayments = (params, meta = {}) => ({
  type: types.FETCH_PAYMENTS,
  payload: {
    request: {
      method: 'GET',
      url: PAYMENTS_FILTER_URL,
      params: {
        projection: 'details',
        ...params,
      },
    }
  },
  meta
});

/**
 * @param {PaymentDetails[]} data
 * @param {object} [meta={}]
 * @returns {FetchPaymentsSuccessAction}
 */
export const fetchPaymentsSuccess = (data, meta = {}) => ({
  type: types.FETCH_PAYMENTS_SUCCESS,
  payload: data,
  meta
});

/**
 * @param {string} error
 * @param {object} [meta={}]
 * @returns {FetchPaymentsFailureAction}
 */
export const fetchPaymentsFailure = (error, meta = {}) => ({
  type: types.FETCH_PAYMENTS_FAILURE,
  payload: error,
  error: true,
  meta
});

/**
 * @param {object} params
 * @param {object} [meta={}]
 * @returns {FetchTotalAmountRequestAction}
 */
export const fetchTotalAmount = (params, meta = {}) => ({
  type: types.FETCH_TOTAL_AMOUNT,
  payload: {
    request: {
      method: 'GET',
      url: PAYMENTS_REDUCE_URL,
      params: {
        ...params,
        status: PaymentStatus.SUCCESS,
        typeNot: PAYMENT_TYPE.EXTERNAL,
        reducer: 'amount,sum'
      }
    }
  },
  meta,
});

/**
 * @param {number} data
 * @param {object} [meta={}]
 * @returns {FetchTotalAmountSuccessAction}
 */
export const fetchTotalAmountSuccess = (data, meta = {}) => ({
  type: types.FETCH_TOTAL_AMOUNT_SUCCESS,
  payload: data,
  meta
});

/**
 * @param {string} error
 * @param {object} [meta={}]
 * @returns {FetchTotalAmountFalureAction}
 */
export const fetchTotalAmountFailure = (error, meta = {}) => ({
  type: types.FETCH_TOTAL_AMOUNT_FAILURE,
  payload: error,
  error: true,
  meta
});

export const setPaymentDashboardFilter = (field, value, meta = {}) => ({
  type: types.SET_PAYMENT_DASHBOARD_FILTER,
  payload: { field, value },
  meta,
});

export const setPaymentDashboardFilters = (filters, meta = {}) => ({
  type: types.SET_PAYMENT_DASHBOARD_FILTERS,
  payload: filters,
  meta,
});

export const removePaymentDashboardFilter = (field, value, meta = {}) => ({
  type: types.REMOVE_PAYMENT_DASHBOARD_FILTER,
  payload: {
    field,
    value,
  },
  meta,
});

export const clearPaymentDashboardFilters = (payload, meta = {}) => ({
  type: types.CLEAR_PAYMENT_DASHBOARD_FILTER,
  payload,
  meta,
});

/**
 * @param {Object} [meta={}]
 * @returns {import('modules/global/generic.types').Action<undefined>}
 */
export const openExportPaymentModal = (meta = {}) => ({
  type: types.OPEN_EXPORT_PAYMENT_MODAL,
  meta,
});

/**
 * @param {Object} [meta={}]
 * @returns {import('modules/global/generic.types').Action<undefined>}
 */
export const closeExportPaymentModal = (meta = {}) => ({
  type: types.CLOSE_EXPORT_PAYMENT_MODAL,
  meta,
});

/**
 * @param {import('./types').ExportPaymentProps} data
 * @param {Object} [meta={}]
 * @return {import('./types').ExportPaymentAction}
 */
export const exportPayment = (data, meta = {}) => ({
  type: types.EXPORT_PAYMENT_REQUEST,
  payload: {
    request: {
      url: PAYMENTS_EXPORT_URL,
      method: 'POST',
      data,
    },
  },
  meta,
});

/**
 * @param {Object} [meta={}]
 * @returns {import('modules/global/generic.types').Action<undefined>}
 */
export const exportPaymentSuccess = (meta = {}) => ({
  type: types.EXPORT_PAYMENT_SUCCESS,
  meta,
});

/**
 * @param {string} message
 * @param {Object} [meta={}]
 * @returns {import('modules/global/generic.types').Action<string>}
 */
export const exportPaymentFailure = (message, meta = {}) => ({
  type: types.EXPORT_PAYMENT_FAILURE,
  payload: message,
  error: true,
  meta,
});
